export const calculateUsagePercent = (metric, usedKey, totalKey) => {
    const used = metric && metric[usedKey];
    const total = metric && metric[totalKey];
    if (!Number.isFinite(used) || !Number.isFinite(total) || total <= 0) {
        return 0;
    }
    return Math.trunc(used * 100 / total);
};

const parseAgentVersion = version => {
    if (typeof version !== 'string') {
        return null;
    }
    const match = version.trim().match(/^v?(\d+)\.(\d+)\.(\d+)(?:-([0-9A-Za-z.-]+))?(?:\+[0-9A-Za-z.-]+)?$/);
    if (!match) {
        return null;
    }
    return {
        parts: match.slice(1, 4).map(Number),
        prerelease: match[4] || ''
    };
};

export const isAgentUpdateAvailable = (metric, currentVersion) => {
    const installed = parseAgentVersion(metric && metric.version);
    const available = parseAgentVersion(currentVersion);
    if (!installed || !available) {
        return false;
    }

    for (let index = 0; index < available.parts.length; index += 1) {
        if (installed.parts[index] !== available.parts[index]) {
            return installed.parts[index] < available.parts[index];
        }
    }
    return Boolean(installed.prerelease) && !available.prerelease;
};
